import React, { Component } from 'react';
import {
	Col,
	Row
} from 'reactstrap';
import axios from 'axios';

import landingPageDress from '../img/landing-page-dress-small.png';

export default class HomeContainer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			fetched: false,
			active: false,
			img: null,
			header: '',
			body: ''
		}
	}
	get() {
		if (process.env.REACT_APP_FRONT_END === "true") {
			this.setState({
				fetched: true
			});
			return;
		}
		axios.get('/api/home-container')
		.then((res) => {
			this.setState({
				fetched: true,
				active: res.data.active,
				img: (res.data.img) ? 'data:' + res.data.img.mimetype + ';base64,' + res.data.img.buffer : null,
				header: res.data.header,
				body: res.data.body
			});
		})
		.catch((err) => {
			console.log(err);
			this.setState({
				fetched: true,
				active: false
			});
		});
	}
	componentDidMount() {
		this.get();
	}

	render() {
		if (!this.state.fetched) {
			return (null);
		}
		if (!this.state.active) {
			return (
				<div className="text-center d-none d-lg-block">
					<img src={landingPageDress} className="img-fluid" alt="" />
				</div>
			);
		}
		return (
			<div className="text-center">
				{this.state.img &&
					<img src={this.state.img} className="img-fluid" alt="" />
				}
				{this.state.header &&
					<h3 className="mt-4">{this.state.header}</h3>
				}
				{this.state.body &&
					<div>{this.state.body}</div>
				}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/HomeContainer.js